export class PaymentBackUrlParams {
  paymentID: string | null;
  orderID: number | null;
  opaque: string | null;

  constructor(paymentID: string | null, orderID: number | null, opaque: string | null) {
    this.paymentID = paymentID;
    this.orderID = orderID;
    this.opaque = opaque;
  }
}
